import Chart from 'chart.js';

function isDarkMode() {
  if (typeof document === 'undefined' || !document.documentElement) return false;
  return document.documentElement.getAttribute('data-theme') === 'dark';
}

function getDarkBackgroundColor() {
  const value = getComputedStyle(document.documentElement).getPropertyValue('--color-bg-white').trim();
  return value || '#1a1a1a';
}

Chart.pluginService.register({
  beforeDraw(chart) {
    if (!isDarkMode()) return;
    const ctx = chart.ctx;
    if (!chart.chartArea) return;
    ctx.save();
    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillStyle = getDarkBackgroundColor();
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  }
});

if (typeof window !== 'undefined') {
  window.addEventListener('theme-changed', () => {
    Object.keys(Chart.instances || {}).forEach(key => {
      const instance = Chart.instances[key];
      if (instance && instance.canvas) {
        instance.update();
        instance.render();
      }
    });
  });
}
